import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import api from "../api";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { HelpCircle } from "lucide-react";
import CalloutImage from "./academy/CalloutImage";

const PATH_TO_SCREEN = {
  "/": "dashboard", "/dashboard": "dashboard", "/apartments": "apartments", "/pipeline": "pipeline",
  "/calendar": "calendar", "/bookings": "bookings", "/guests": "guests", "/cleanings": "cleanings",
  "/maintenance": "maintenance", "/payments": "payments", "/owners": "owners", "/qr-center": "qr",
  "/owner-portal": "owner_portal", "/accounting": "accounting", "/release": "release",
  "/local-guide": "local_guide", "/settings": "settings", "/academy": "academy",
};

export default function HelpButton() {
  const location = useLocation();
  const [guide, setGuide] = useState(null);
  const [open, setOpen] = useState(false);

  const seg = "/" + (location.pathname.split("/")[1] || "");
  const screen = PATH_TO_SCREEN[location.pathname] || PATH_TO_SCREEN[seg];

  useEffect(() => {
    setGuide(null);
    if (!screen) return;
    api.get(`/academy/contextual?screen_key=${screen}`).then((r) => setGuide(r.data.guide)).catch(() => {});
  }, [screen]);

  if (!screen || !guide) return null;

  return (
    <>
      <Button variant="ghost" size="icon" className="text-slate-500 hover:text-indigo-600" onClick={() => setOpen(true)} title="Aiuto su questa schermata" data-testid="contextual-help-btn">
        <HelpCircle size={19} />
      </Button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="max-h-[90vh] max-w-2xl overflow-y-auto" data-testid="contextual-help-dialog">
          <div>
            <div className="mb-1 text-xs font-medium uppercase tracking-wide text-indigo-600">Aiuto contestuale</div>
            <DialogTitle className="font-head text-xl font-semibold text-slate-900">{guide.title}</DialogTitle>
            {guide.summary && <DialogDescription className="mt-1 text-sm text-slate-500">{guide.summary}</DialogDescription>}
            <div className="mt-4 space-y-4">
              {(guide.steps || []).map((s) => (
                <div key={s.id} className="flex gap-3">
                  <span className="flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-indigo-600 text-xs font-bold text-white">{s.number}</span>
                  <div className="min-w-0 flex-1">
                    {s.title && <p className="font-semibold text-slate-800">{s.title}</p>}
                    {s.text && <p className="text-sm text-slate-600">{s.text}</p>}
                    {s.image_url && <div className="mt-2 max-w-lg"><CalloutImage src={s.image_url} callouts={s.callouts} /></div>}
                  </div>
                </div>
              ))}
            </div>
            {(guide.faqs || []).length > 0 && (
              <div className="mt-4 border-t pt-3">
                <p className="mb-2 text-sm font-semibold text-slate-700">FAQ</p>
                {guide.faqs.map((f, i) => <div key={i} className="mb-2"><p className="text-sm font-medium text-slate-800">{f.q}</p><p className="text-sm text-slate-600">{f.a}</p></div>)}
              </div>
            )}
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
}
